// to know if level 8 and 9 should use object, verb or subject with extended levels

import { LevelExtension } from '../enums';

class LevelExtensionProgress {
  value = $state<LevelExtension>(LevelExtension.Object);
}
export const levelExtensionProgress = new LevelExtensionProgress();